import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Layout from './components/Layout';
import Home from './pages/Home';
import Exchange from './pages/Exchange';
import About from './pages/About';
import Header from "./components/Header";
import {useUser} from "./hooks/useUser";
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
    const location = useLocation();

    useUser();





    return (

        <>

            <Header />

            <ScrollToTop />

            <AnimatePresence mode="wait" initial={false}>

                <Routes location={location} key={location.pathname}>
                    <Route element={<Layout />}>
                        <Route index element={<Home />} />
                        <Route path={'/*'} element={<Home />} />
                        <Route path="/exchange" element={<Exchange />} />
                        <Route path="/about" element={<About />} />
                    </Route>
                </Routes>
            </AnimatePresence>

        </>
    );
}
